import styled from 'styled-components'
import { Button, IconButton } from '@material-ui/core'

export const HistoryHeader = styled.div`
  display: flex;
  width: 100%;
  padding: 24px;
  flex-direction: column;
  gap: 16px;
  align-items: flex-end;
  border-bottom: 0.909px solid #E5E7EB;
`

export const HistoryHeaderTopRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  /* @noflip */ direction: rtl;
`

export const HeaderTitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  /* @noflip */ direction: rtl;
`

export const BackButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: 6px;
  color: #364153;
  text-transform: none;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 500;
`

export const HistoryTitle = styled.div`
  color: #101828;
  text-align: center;
  font-family: Rubik;
  font-size: 22px;
  font-weight: 600;
`

export const ClockIconButton = styled(IconButton)`
  display: flex;
  width: 44px;
  height: 44px;
  background: #EFF6FF;
  color: #1447E6;
  &:hover { background: #DBEAFE; }
`

export const Breadcrumb = styled.div`
  width: 100%;
  color: #6A7282;
  text-align: right;
  /* @noflip */ direction: rtl;
  font-family: Rubik;
  font-size: 13px;
  font-weight: 400;
`

export const BreadcrumbActive = styled.span`
  color: #1447E6;
  font-weight: 500;
`

export const FilterCardRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: flex-end;
  /* @noflip */ direction: rtl;
  gap: 16px;
  flex-wrap: wrap;
`

export const ProtocolBadgeCard = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 14px;
  border-radius: 8px;
  border: 1px solid #BEDBFF;
  background: #EFF6FF;
  flex: 1 1 450px;
  max-width: 60%;
  min-width: 280px;
  box-sizing: border-box;
`

export const ProtocolBadgeTexts = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  min-width: 0;
`

export const DateFieldsRow = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-end;
  /* @noflip */ direction: rtl;
  flex-wrap: wrap;
`

export const DateField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1 1 140px;
  min-width: 120px;
  max-width: 200px;
  /* Label and value both sit centred over the field. */
  text-align: center;
  input {
    text-align: center;
  }
`

export const ProtocolBadgeLabel = styled.div`
  color: #4C5564;
  font-family: Rubik;
  font-size: 12px;
  font-weight: 400;
`

export const ProtocolBadgeTitle = styled.div`
  color: #101828;
  font-family: Rubik;
  font-size: 16px;
  font-weight: 600;
  word-break: break-word;
`

export const HistoryBody = styled.div`
  display: flex;
  width: 100%;
  padding: 24px;
  flex-direction: column;
  gap: 16px;
`

export const StatusBadge = styled.div<{ $color: string; $bg: string }>`
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 20px;
  background: ${p => p.$bg};
  color: ${p => p.$color};
  font-family: Rubik;
  font-size: 13px;
  font-weight: 500;
`

export const StatusTransitionCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  /* @noflip */ direction: rtl;
`

export const EditorCell = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: #364153;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 400;
`

export const DateCell = styled.div`
  color: #364153;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 400;
  /* @noflip */ direction: rtl;
`

// Free-text note on a status change - today only a rejection has one.
export const NoteCell = styled.div`
  color: #364153;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 400;
  /* @noflip */ direction: rtl;
  word-break: break-word;
`
